import { useState } from "react";
import { useGetWooProductsQuery } from "../features/api/wooApiSlice";
import WooProductFilters from "./WooProductFilters";
import "./wooPage.scss";
import LoadingSpinner from "../components/loader/Loader";

const WooProductsPage = () => {
  const [filters, setFilters] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const { data: products = [], isLoading } = useGetWooProductsQuery(filters);
  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="main_wrapper">
      <div className="woo-products-page">
        {/* Mobile Filter Toggle */}
        <div className="mobile-filter-toggle">
          <button onClick={() => setShowFilters(!showFilters)}>
            {showFilters ? "Close Filters" : "Show Filters"}
          </button>
        </div>

        <div className="layout">
          {/* Filters */}
          <aside className={`filters ${showFilters ? "show" : ""}`}>
            <WooProductFilters onFilterChange={setFilters} />
          </aside>

          {/* Products */}
          <main className="products">
            {isLoading && <p>Loading products...</p>}
            {!isLoading && products.length === 0 && <p>No products found.</p>}
            {!isLoading &&
              products.map((p) => {
                // Check if the product name matches the specific product
                const isCustomProduct =
                  p.name === "HUT PPP Satin Gloss/High Gloss Bars_2oz";
                // Create a dynamic class name
                const cardClassName = `product-card ${
                  isCustomProduct ? "custom-product-hut" : ""
                }`;

                return (
                  <div className={cardClassName} key={p.id}>
                    <img src={p.images?.[0]?.src} alt={p.name} />
                    <h4>{p.name}</h4>
                    <p dangerouslySetInnerHTML={{ __html: p.price_html }} />
                    <button>Learn More</button>
                    {/* <button>Add to Cart</button> */}
                  </div>
                );
              })}
          </main>
        </div>
      </div>
    </div>
  );
};

export default WooProductsPage;
